export const CHANGE_LOCALE = 'locale/CHANGE'



// WEBPACK FOOTER //
// ./state/types/locale.js